import { useApi } from '@omnipresentgroup/api';
import type {
  CreateInvoicePaymentRequest,
  CreateInvoicePaymentResponse,
  CreateInvoicePaymentResponseAPI,
} from '@omnipresentgroup/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { transformContractorPaymentFromAPI } from '../../contractorsPayments/mappers';
import { API_BASE, API_PATH } from '../constants';
import { transformCreateInvoicePaymentRequestToAPI } from '../mappers';

export const useCreateContractorInvoicePaymentMutation = () => {
  const { POST } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateInvoicePaymentRequest) => {
      const transformedPayload =
        transformCreateInvoicePaymentRequestToAPI(payload);

      return new Promise<CreateInvoicePaymentResponse>((resolve, reject) => {
        POST<CreateInvoicePaymentResponseAPI>({
          path: `${API_BASE}/${API_PATH}/payments`,
          body: transformedPayload,
        })
          .then((response) =>
            resolve(transformContractorPaymentFromAPI(response)),
          )
          .catch((error) => reject(error));
      });
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
      }),
  });
};
